import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const PrivacyPage = lazyPage(() => import("./pages/PrivacyPage"), "PrivacyPage");
const TermsPage = lazyPage(() => import("./pages/TermsPage"), "TermsPage");

export const legalModule: WebModule = {
  id: "legal",
  nav: null,
  routes: [],
  publicRoutes: [
    { path: "/legal/terms", element: <TermsPage /> },
    { path: "/legal/privacy", element: <PrivacyPage /> },
  ],
};
